import React, { useState, useEffect } from 'react';
import { usePWAInstall } from '../hooks/usePWAInstall.ts';
import { isMobileDevice } from '../utils/deviceUtils.ts';
import './PWAInstallPrompt.css';

const PWAInstallPrompt: React.FC = () => {
  const { isInstalled, isIOS, deferredPrompt } = usePWAInstall();
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Verificar se é dispositivo móvel
    setIsMobile(isMobileDevice());
    
    // Atualizar quando a janela redimensionar
    const handleResize = () => {
      setIsMobile(isMobileDevice());
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!deferredPrompt || isInstalled) {
      setShowInstallPrompt(false);
      return;
    }
    const timer = setTimeout(() => {
      if (!showInstallPrompt) {
        setShowInstallPrompt(true);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [deferredPrompt, isInstalled, showInstallPrompt]);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      // Para iOS, não fazer nada (o componente iOSInstallInstructions cuidará disso)
      if (isIOS) {
        setShowInstallPrompt(false);
        return;
      }
      return;
    }

    try {
      await deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      
      if (outcome === 'accepted') {
        console.log('PWA instalada com sucesso');
      } else {
        console.log('Instalação da PWA cancelada');
      }
      
      setShowInstallPrompt(false);
      setTimeout(() => window.location.reload(), 500);
    } catch (error) {
      console.error('Erro ao instalar PWA:', error);
    }
  };

  const handleDismiss = () => {
    setShowInstallPrompt(false);
    // Não mostrar novamente por 24 horas
    localStorage.setItem('pwa-install-dismissed', Date.now().toString());
  };

  // Não mostrar se:
  // - Já estiver instalado
  // - Não for dispositivo móvel (desktop)
  // - For iOS (usa outro componente)
  // - Não tiver deferredPrompt
  // - Não mostrar o prompt
  if (isInstalled || !isMobile || !showInstallPrompt || isIOS || !deferredPrompt) {
    return null;
  }

  // Verificar se foi dispensado recentemente (24 horas)
  const dismissedTime = localStorage.getItem('pwa-install-dismissed');
  if (dismissedTime) {
    const timeDiff = Date.now() - parseInt(dismissedTime);
    if (timeDiff < 24 * 60 * 60 * 1000) { // 24 horas
      return null;
    }
  }

  return (
    <div className="pwa-install-prompt">
      <div className="pwa-install-content">
        <div className="pwa-install-icon">
          📱
        </div>
        <div className="pwa-install-text">
          <h3>Instalar Prumo</h3>
          <p>Instale nosso app para acesso rápido e funcionalidades offline!</p>
        </div>
        <div className="pwa-install-actions">
          <button 
            className="pwa-install-button"
            onClick={handleInstallClick}
          >
            Instalar
          </button>
          <button 
            className="pwa-dismiss-button"
            onClick={handleDismiss}
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
